`use strict`;

class Draad_Counter {

    constructor( counter ) {
        this.counter = counter;
        this.counterNumber = this.counter.dataset.counterNumber;
        if ( ! this.counterNumber ) {
            return;
        }

        this.startNumber = 0;
        this.endNumber = parseFloat( this.counterNumber );
        if ( isNaN( this.endNumber ) || this.endNumber <= 0 ) {
            return;
        }

        this.duration = 2500;
        this.stepTime = Math.max( Math.floor( this.duration / this.endNumber ), 15 );
        this.incrementStep = this.endNumber / ( this.duration / this.stepTime );
        this.currentNumber = this.startNumber;
        this.decimalPlaces = this.endNumber % 1 === 0 ? 0 : ( this.endNumber.toString().split(".")[1] || "" ).length;
        this.timer = null;

        // Initial check on page load
        this.startAnimation();

        // Check if the counter is in viewport on scroll
        window.addEventListener( 'scroll', () => this.startAnimation() );
    }

    start() {
        this.timer = setInterval( () => this.incrementNumber(), this.stepTime );
    }

    incrementNumber() {
        this.currentNumber = Math.min( this.currentNumber + this.incrementStep, this.endNumber );
        this.counter.textContent = this.currentNumber.toFixed( this.decimalPlaces );

        if ( this.currentNumber >= this.endNumber ) {
            clearInterval( this.timer );
            this.counter.textContent = this.endNumber.toFixed( this.decimalPlaces );
        }
    }

    isInViewport() {
        const rect = this.counter.getBoundingClientRect();
        return rect.top < window.innerHeight && rect.bottom > 0;
    }

    // Function to start animation when in viewport
    startAnimation() {
        if ( ! this.counter.animated && this.isInViewport() ) {
            this.counter.animated = 'true';
            this.start();
        }
    }

}

// Initialize the counters
document.addEventListener('DOMContentLoaded', () => {
    // get all data-counter-number attributes on a page
    const counters = document.querySelectorAll( '[data-counter-number]' );
    if ( ! counters.length ) {
        return
    }

    counters.forEach( counterElement => {
        // Check if the data-counter-number attribute is a valid number else directly return
        if ( ! counterElement.dataset.counterNumber || isNaN( counterElement.dataset.counterNumber ) ) {
            return;
        }

        new Draad_Counter( counterElement );
    } );
} );